const isRtl = _ => {
    return !(localStorage.getItem('lang') === 'en')
}

const getCurrentLang = _ => {
    return localStorage.getItem('lang') === 'en' ? 'en' : 'ar'
}

export  { isRtl, getCurrentLang }